import React, { FC } from 'react';
import { useI18n, useSelector } from '~Hooks';
import HandyPageWrapper from '~Scenes/Handy/Components/HandyPageWrapper';
import { Card } from '~Styles';
import SelectDeviceV2 from './SelectDeviceV2';
import SelectDevice from './SelectDevice';
import { useStorage } from '~Components/Storage';

const DeviceSettings: FC = () => {
  const { i18n } = useI18n();
  const [storage] = useStorage();

  const companyFlags = useSelector((state) => state.companyFlags);

  return (
    <HandyPageWrapper pageTitle={i18n('Handy.Settings.DeviceTitle')}>
      {!storage.taxComplianceDeviceId && (
        <Card marginTop="small" padding="small">
          Please select a device below to use this terminal.
        </Card>
      )}

      {companyFlags.useNewLicenses ? <SelectDeviceV2 /> : <SelectDevice />}
    </HandyPageWrapper>
  );
};

export default DeviceSettings;
